module.exports = __webpack_public_path__ + "img/rental.212fc2f0.png";